<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-intro">
          <router-link class="footer-brand" to="/" aria-label="WizzTech home">
            <img src="../../assets/img/newlogo.png" alt="" />
            <span>WizzTech</span>
          </router-link>
          <p>Hands-on IT, worldwide.</p>
        </div>
        <nav class="footer-navigation" aria-label="Services">
          <h2>Services</h2>
          <ul>
            <li>
              <router-link to="/services#device-onboarding"
                >Device onboarding</router-link
              >
            </li>
            <li>
              <router-link to="/services#secure-offboarding"
                >Offboarding &amp; secure wipe</router-link
              >
            </li>
            <li>
              <router-link to="/services#wifi-surveys"
                >WiFi surveys</router-link
              >
            </li>
            <li>
              <router-link to="/services#break-fix"
                >Break/Fix</router-link
              >
            </li>
            <li><router-link to="/services#rollouts">Rollouts</router-link></li>
            <li>
              <router-link to="/services#data-center-support"
                >Data center support</router-link
              >
            </li>
          </ul>
        </nav>
        <nav class="footer-navigation" aria-label="Company">
          <h2>Company</h2>
          <ul>
            <li><router-link to="/about">About</router-link></li>
            <li>
              <router-link to="/why-us">Why us</router-link>
            </li>
            <li>
              <router-link to="/coverage">Coverage</router-link>
            </li>
            <li><router-link to="/contact">Contact</router-link></li>
            <li>
              <router-link to="/engineer-network"
                >Join our engineer network</router-link
              >
            </li>
          </ul>
        </nav>
        <div class="footer-contact">
          <h2>Contact</h2>
          <a class="email" href="mailto:info@wizztech.us">info@wizztech.us</a>
          <p>Phone: <a href="tel:+447412897786">+44 7412 897786</a></p>
          <p class="contact-hours">Office hours: 08:00 AM–08:00 PM</p>
          <p class="contact-timezone">Time zone: UK (GMT/BST)</p>
        </div>
      </div>
      <div class="footer-details">
        <div id="coverage" class="offices">
          <h2>Our offices</h2>
          <h3>WIZZ TECH LTD</h3>
          <p>
            71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United
            Kingdom
          </p>
          <h3>Wizz Tech LLC</h3>
          <p>30 N Gould St #5319, Sheridan, WY 82801, United States</p>
        </div>
        <div class="footer-social">
          <h2>Follow us</h2>
          <div class="social-links">
            <a
              href="https://www.linkedin.com/company/wizz-tech"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path
                  d="M5.2 7.5a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4ZM3.7 9h3v11h-3V9Zm5.2 0h2.9v1.5h.1c.4-.8 1.4-1.8 3.1-1.8 3.3 0 4 2.1 4 4.9V20h-3v-5.7c0-1.4 0-3.1-1.9-3.1s-2.2 1.5-2.2 3V20h-3V9Z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2026 WizzTech. All rights reserved.</p>
        <span aria-hidden="true">·</span>
        <router-link to="/privacy-policy">Privacy Policy</router-link>
        <span aria-hidden="true">·</span>
        <router-link to="/terms-and-conditions"
          >Terms &amp; Conditions</router-link
        >
      </div>
    </div>
  </footer>
</template>

<style scoped>
.site-footer {
  box-sizing: border-box;
  width: 100%;
  min-height: 571px;
  padding: 56px max(24px, calc((100% - 1120px) / 2)) 32px;
  background: #0b1f3a;
  color: #f4f6fa;
  font-family: "Inter", sans-serif;
}
.footer-inner {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
}
.footer-top {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 32px;
}
.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #f4f6fa;
  font-size: 20px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
.footer-brand img {
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  padding: 3px;
  background: #fff;
  border-radius: 8px;
  object-fit: contain;
}
.footer-intro p {
  margin: 12px 0 0;
}
h2 {
  margin: 0 0 10px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}
p,
a {
  font-size: 15px;
  line-height: 24px;
}
p,
.footer-navigation a,
.email,
.footer-bottom {
  color: #acb8c8;
}
.footer-navigation ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.footer-navigation li + li {
  margin-top: 7px;
}
.footer-contact p {
  margin: 8px 0 0;
}
a {
  text-decoration: none;
}
a:hover,
a:focus-visible {
  color: #57d3ca;
  text-decoration: underline;
}
.footer-details {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 32px;
}
.offices {
  grid-column: 1 / 4;
}
.footer-details h2 {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 8px;
}
.offices h3 {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
}
.offices p {
  margin: 0 0 10px;
  color: #d9e0e9;
  font-size: 14px;
  line-height: 22px;
}
.offices p:last-child {
  margin-bottom: 0;
}
.social-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #117b76;
  color: #fff;
}
.social-links a:hover {
  background: #0d6561;
}
.social-links svg {
  width: 22px;
  height: 22px;
}
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  border-top: 1px solid #acb8c8;
  padding-top: 32px;
}
.footer-bottom p {
  margin: 0;
}
.footer-bottom a {
  color: inherit;
}
</style>
